<template>
  <OnClickOutside
    class="useraccount flyout flex flex-col border border-solid border-secondary w-full left-0 sm:left-auto sm:right-0 sm:top-full fixed sm:absolute sm:w-[300px] text-paragraph"
    @trigger="close">
    <div v-if="user?.userInfo && loggedIn">
      <div class="p-4 border solid border-secondary">
        <div class="text-lg">Hallo {{ user?.userName }}</div>
      </div>
      <div class="p-4 bg-secondary flex flex-col gap-4 border solid border-secondary">
        <NuxtLink to="/shop/mein-expert/persoenliche-daten" :external="true">
          <div class="flex gap-4 items-center">
            <BasicIcon :name="'address-card-regular'" class="w-4 h-4 scale-150 text-primary" />
            Meine persönlichen Daten
          </div>
        </NuxtLink>
        <NuxtLink to="/shop/mein-expert/persoenliche-daten#mydata" :external="true">
          <div class="flex gap-4 items-center">
            <BasicIcon :name="'house-chimney-solid'" class="w-4 h-4 scale-150 text-primary" />
            Meine Adresse
          </div>
        </NuxtLink>
        <NuxtLink to="/shop/mein-expert/bestellungen" :external="true">
          <div class="flex gap-4 items-center">
            <BasicIcon class="w-4 align-text-top text-primary" :name="'cart-shopping-solid'" />
            Meine Bestellungen
          </div>
        </NuxtLink>
        <NuxtLink :to="'/shop/wishlist'" aria-label="Zur Wunschliste">
          <div class="flex gap-4 items-center">
            <BasicIcon class="w-4 h-4 text-primary cursor-pointer align-text-top" :name="'heart-shape'" />
            Mein Merkzettel
          </div>
        </NuxtLink>
        <template v-if="fullPaybackFeature">
          <NuxtLink :to="'/shop/mein-expert/payback'" aria-label="Zu PAYBACK">
            <div class="flex gap-4 items-center">
              <BasicIcon class="w-4 h-4 cursor-pointer align-text-top scale-[250%]" :name="'payback'" />
              Mein PAYBACK
            </div>
          </NuxtLink>
        </template>
      </div>
      <button class="btn-primary w-full p-4 text-center border solid border-primary" @click="triggerLogOut()">
        Abmelden
      </button>
    </div>

    <div v-else>
      <div class="p-4 gap-4 items-center flex">
        <BasicIcon :name="'lock-solid'" class="w-4 h-4 scale-150 text-primary" />
        <div>
          <div class="text-lg">Sie sind nicht eingeloggt</div>
          <div>
            <NuxtLink class="text-primary text-sm cursor-pointer" @click.prevent="startLogin">Jetzt einloggen</NuxtLink>
          </div>
        </div>
      </div>
      <div class="btn-primary p-4 gap-2 items-center flex w-full text-sm cursor-pointer"
        @click="login('keycloak', { prompt: 'create' })">
        <img class="w-4 scale-150" alt="Register"
          src="https://cdn.expert.de/static/resources/private/expert/icons/img-expert-symbol-white.svg" />
        Neu bei expert? <strong>Jetzt Registrieren</strong>
      </div>
    </div>
  </OnClickOutside>
</template>
<script setup lang="ts">
import { OnClickOutside } from '@vueuse/components';
import { ref } from 'vue';

const { login, loggedIn, user, logout } = useOidcAuth();
const emit = defineEmits(['changeFlyOutState']);
const featureStatePayback = computed(() => useFeatureState('exsi-1556') && useCurrentStore().value.paybackStore);
const fullPaybackFeature = computed(() => featureStatePayback.value && useFeatureValue('exsi-1556').value?.name == 'full');
const showUserAccountFlyout = ref(false);

function close() {
  emit('changeFlyOutState', showUserAccountFlyout);
}

const startLogin = () => {
  login('keycloak', { callbackRedirectUrl: useRoute().fullPath });
}

const triggerLogOut = async () => {
  await $fetch('/api/user/preLogout');
  await logout();
};
</script>
